module.exports = __webpack_public_path__ + "static/img/img14.abce153c.png";